import React, { createContext, useContext, useEffect, useState, useCallback, useRef } from 'react';
import axios from 'axios';
import { API_URL } from '../utils/api';

// Egyetlen 60 s-os poll (GET /api/live) a korábbi 3 külön időzítő helyett
// (értesítés-számláló, reload-version, nyomtatási sor badge).
const LiveContext = createContext({ live: null, refresh: () => {} });
const POLL_MS = 60_000;
const RELOAD_KEY = 'last_reload_version';

// Admin által kiadott globális reload: első indulásnál baseline, később ha nő → cache-bypass reload
function checkReloadVersion(remoteRaw) {
  const remote = Number(remoteRaw || 0);
  const local = Number(localStorage.getItem(RELOAD_KEY) || 0);
  if (remote > 0 && local === 0) {
    localStorage.setItem(RELOAD_KEY, String(remote));
  } else if (remote > local) {
    localStorage.setItem(RELOAD_KEY, String(remote));
    window.location.reload(true);
  }
}

export function LiveProvider({ children, enabled = true }) {
  const [live, setLive] = useState(null);
  const inflight = useRef(false);

  const refresh = useCallback(async () => {
    if (!enabled || inflight.current) return;
    inflight.current = true;
    try {
      const r = await axios.get(`${API_URL}/api/live`, { withCredentials: true, validateStatus: (s) => s < 500 });
      if (r.status === 200 && r.data) {
        setLive(r.data);
        checkReloadVersion(r.data.reload_version);
      }
    } catch { /* silent */ } finally { inflight.current = false; }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return undefined;
    refresh();
    const id = setInterval(() => { if (!document.hidden) refresh(); }, POLL_MS);
    const onVisible = () => { if (!document.hidden) refresh(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { clearInterval(id); document.removeEventListener('visibilitychange', onVisible); };
  }, [enabled, refresh]);

  return <LiveContext.Provider value={{ live, refresh }}>{children}</LiveContext.Provider>;
}

export function useLive() {
  return useContext(LiveContext);
}
